var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55 16.1998H4.04999C3.05588 16.1998 2.24999 15.3939 2.25 14.3998L2.25007 3.59979C2.25008 2.60569 3.05596 1.7998 4.05007 1.7998H12.1503C13.1444 1.7998 13.9503 2.60569 13.9503 3.5998V7.1998M14.85 14.8498L15.75 15.7498M5.40028 5.3998H10.8003M5.40028 8.0998H10.8003M5.40028 10.7998H8.10028M15.3 13.0498C15.3 14.2924 14.2926 15.2998 13.05 15.2998C11.8074 15.2998 10.8 14.2924 10.8 13.0498C10.8 11.8072 11.8074 10.7998 13.05 10.7998C14.2926 10.7998 15.3 11.8072 15.3 13.0498Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolicy);
export default __webpack_public_path__ + "static/media/IconPolicy.7e9fc3fe7a34bc243de29b0b28d2f916.svg";
export { ForwardRef as ReactComponent };